import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import AdvancedAdminControlsLayoutQuery from './__generated__/AdvancedAdminControlsLayoutQuery.graphql';
import AdvancedAdminControlsRecommendationsQuery from './__generated__/AdvancedAdminControlsRecommendationsQuery.graphql';

export const advancedAdminControlsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-advanced-admin-controls-entrypoint" */ './AdvancedAdminControlsPage.tsx'
			),
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => {
		const { appEditions, cloudId, orgId, productEntitlementDetails } = tenantContext;

		// Calculate current time once to avoid volatile variable usage in render logic
		const currentTime = Date.now();

		const trialEndTime = productEntitlementDetails?.['jira-software']?.trialEndTime;
		const firstPredunningEndTime =
			productEntitlementDetails?.['jira-software']?.firstPredunningEndTime;

		const isInTrial = !!trialEndTime && currentTime <= trialEndTime;

		const isInPreDunning = !!firstPredunningEndTime && currentTime <= firstPredunningEndTime;

		const queries = {
			advancedAdminControlsRecommendationsQuery: {
				parameters: AdvancedAdminControlsRecommendationsQuery,
				variables: {
					context: {
						useCase: 'jiraAdvancedAdminControlsRerank',
						tenantId: cloudId,
						product: 'jira',
						orgId,
						custom: {
							edition: appEditions?.software,
							isInTrial,
							isInPreDunning,
						},
					},
					first: 10,
				},
				fetchPolicy: 'store-or-network',
			},
			advancedAdminControlsLayoutQuery: {
				parameters: AdvancedAdminControlsLayoutQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					hamsProductKey: 'jira-software.ondemand',
					offeringKey: '6dd805b4-da75-4374-a7a7-cf0b12f7ea07',
				},
			},
		};

		return { queries };
	},
});
